module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/wedding-mobile@3x-672a39d4f8368f602a60eb05290daa8c.jpg";